import DOMPurify from "dompurify";

// Every page that renders backend-stored rich text (syllabus/circular/
// notification/FAQ/lesson-plan descriptions, etc.) via dangerouslySetInnerHTML
// routes through here first, so a value containing a script/onerror/iframe
// payload (e.g. a compromised staff account, or a field that round-trips
// through a 3rd-party source) can't execute in the viewer's browser.
export const sanitizeHtml = (html) => {
  if (!html) return "";
  return DOMPurify.sanitize(html);
};

// For previews/list rows that only need the plain text (no formatting) —
// safer and simpler than parsing HTML into a detached element and reading
// its textContent, which still lets an <img onerror=...> payload fire.
export const stripHtmlToText = (html) => {
  if (!html) return "";
  return DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
};
